"use client";

import { useLang } from "./lang-provider";
import { Nav } from "./nav";
import { Footer } from "./footer";

export function PrivacyContent() {
  const { t } = useLang();
  return (
    <>
      <Nav />
      <div className="legal-page">
        <h1>{t.privacyTitle}</h1>
        <p className="legal-updated">{t.privacyUpdated}</p>

        <h2>{t.p1Title}</h2>
        <p>{t.p1Body}</p>

        <h2>{t.p2Title}</h2>
        <p><strong>{t.p2IdentityTitle}</strong></p>
        <p>{t.p2IdentityBody}</p>
        <p><strong>{t.p2TrainingTitle}</strong></p>
        <p>{t.p2TrainingBody}</p>
        <p><strong>{t.p2AITitle}</strong></p>
        <p>{t.p2AIBody}</p>
        <p><strong>{t.p2VoiceTitle}</strong></p>
        <p>{t.p2VoiceBody}</p>
        <p><strong>{t.p2DiagTitle}</strong></p>
        <p>{t.p2DiagBody}</p>
        <p><strong>{t.p2BillingTitle}</strong></p>
        <p>{t.p2BillingBody}</p>

        <h2>{t.p3Title}</h2>
        <p>{t.p3Body}</p>

        <h2>{t.p4Title}</h2>
        <p>{t.p4Body}</p>

        <h2>{t.p5Title}</h2>
        <p>{t.p5Body}</p>

        <h2>{t.p6Title}</h2>
        <p>{t.p6Body}</p>

        <h2>{t.p7Title}</h2>
        <p>{t.p7Body}</p>

        <h2>{t.p8Title}</h2>
        <p>{t.p8Body}</p>

        <h2>{t.p9Title}</h2>
        <p>{t.p9Body}</p>

        <h2>{t.p10Title}</h2>
        <p>{t.p10Body}</p>

        <h2>{t.p11Title}</h2>
        <p>{t.p11Body}</p>

        <h2>{t.p12Title}</h2>
        <p>{t.p12Body}</p>
      </div>
      <Footer />
    </>
  );
}

export function TermsContent() {
  const { t } = useLang();
  return (
    <>
      <Nav />
      <div className="legal-page">
        <h1>{t.termsTitle}</h1>
        <p className="legal-updated">{t.termsUpdated}</p>

        <h2>{t.t1Title}</h2>
        <p>{t.t1Body}</p>

        <h2>{t.t2Title}</h2>
        <p>{t.t2Body}</p>

        <h2>{t.t3Title}</h2>
        <p>{t.t3Body}</p>

        <h2>{t.t4Title}</h2>
        <p>{t.t4Body}</p>

        <h2>{t.t5Title}</h2>
        <p>{t.t5Body}</p>

        <h2>{t.t6Title}</h2>
        <p>{t.t6Body}</p>

        <h2>{t.t7Title}</h2>
        <p>{t.t7Body}</p>

        <h2>{t.t8Title}</h2>
        <p>{t.t8Body}</p>

        <h2>{t.t9Title}</h2>
        <p>{t.t9Body}</p>

        <h2>{t.t10Title}</h2>
        <p>{t.t10Body}</p>

        <h2>{t.t11Title}</h2>
        <p>{t.t11Body}</p>

        <h2>{t.t12Title}</h2>
        <p>{t.t12Body}</p>

        <h2>{t.t13Title}</h2>
        <p>{t.t13Body}</p>

        <h2>{t.t14Title}</h2>
        <p>{t.t14Body}</p>

        <h2>{t.t15Title}</h2>
        <p>{t.t15Body}</p>

        <h2>{t.t16Title}</h2>
        <p>{t.t16Body}</p>
      </div>
      <Footer />
    </>
  );
}
